module.exports = __webpack_public_path__ + "img/partnerBannerBlurry.800e23d.webp";